import { ArrowDownOutlined, ArrowUpOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Button, Tooltip, Typography } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { useTranslation } from 'react-i18next';

// Componente para renderizar filas de salvaguardas
interface SafeguardRowProps {
  data: {
    id: number | null;
    name: string;
    [key: string]: any;
  };
  index: number;
  onEdit: (type: string, record: any) => void;
  onDelete: (type: string, record: any) => void;
  editingItem: { type: string; id: number | null };
  editedFormValues: any;
  setEditedFormValues: any;
  modifySafeguard: any;
  setEditingItem: any;
  onMoveUp?: (id: number | null | undefined) => void;
  onMoveDown?: (id: number | null | undefined) => void;
  isFirst?: boolean;
  isLast?: boolean;
}

const SafeguardRow: React.FC<SafeguardRowProps> = ({
  data,
  index,
  onEdit,
  onDelete,
  editingItem,
  editedFormValues,
  setEditedFormValues,
  modifySafeguard,
  setEditingItem,
  onMoveUp,
  onMoveDown,
  isFirst = false,
  isLast = false,
}) => {
  const { t } = useTranslation();
  const { Text } = Typography;
  const displayName = `${index + 1}. ${data.name}`;

  if (editingItem.type === 'safeguard' && editingItem.id === data.id) {
    return (
      <div style={{ marginBottom: '8px', padding: '8px', border: '1px solid #f0f0f0' }}>
        <Text style={{ width: 200, display: 'block', marginBottom: 4 }}>{`${index + 1}.`}</Text>
        <TextArea
          value={editedFormValues.safeguard.name}
          onChange={(e) =>
            setEditedFormValues((prev: any) => ({
              ...prev,
              safeguard: { ...prev.safeguard, name: e.target.value, id: data.id },
            }))
          }
          onPressEnter={modifySafeguard}
          onBlur={modifySafeguard}
          autoFocus
          size='small'
          style={{ width: 200, display: 'block' }}
        />
      </div>
    );
  }
  return (
    <div style={{ marginBottom: '8px', padding: '8px', borderBottom: '1px solid #f0f0f0' }}>
      <Text style={{ width: 200, display: 'block' }}>{displayName}</Text>
      <span style={{ display: 'flex', justifyContent: 'flex-end', gap: '5px' }}>
        <Tooltip title={t('Subir salvaguarda')}>
          <Button
            icon={<ArrowUpOutlined />}
            onClick={() => onMoveUp?.(data.id)}
            size='small'
            type='text'
            disabled={isFirst || !onMoveUp}
            aria-label={t('Subir salvaguarda')}
          />
        </Tooltip>
        <Tooltip title={t('Bajar salvaguarda')}>
          <Button
            icon={<ArrowDownOutlined />}
            onClick={() => onMoveDown?.(data.id)}
            size='small'
            type='text'
            disabled={isLast || !onMoveDown}
            aria-label={t('Bajar salvaguarda')}
          />
        </Tooltip>
        <Tooltip title={t('Editar salvaguarda')}>
          <Button icon={<EditOutlined />} onClick={() => onEdit('safeguard', data)} size='small' type='text' />
        </Tooltip>
        <Tooltip title={t('Eliminar salvaguarda')}>
          <Button
            icon={<DeleteOutlined style={{ color: '#ff4d4f' }} />}
            onClick={() => onDelete('safeguard', data)}
            size='small'
            type='text'
            danger
            aria-label={t('Eliminar salvaguarda')}
          />
        </Tooltip>
      </span>
    </div>
  );
};

export default SafeguardRow;
